import styled from 'styled-components';
import { RadioGroup, Radio } from '@mui/material';
import { Grid } from '@custom-components';
import media from './media';
import { colorGrey03, colorGrey05, colorBlue, supplier } from './colors';
import * as mixins from './mixins';
import { fontBold, fontRegular } from './fonts';
import { TextInput } from '../BuildingBlocks/FormElements/TextInput';

export const SpacedCenteredList = styled.ul`
  > li {
    max-width: 100%;
    &:not(:last-child) {
      padding-bottom: 1em;
    }
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const GridContainer = styled(Grid.Container)`
  ${media.lessThan('md')`padding: 0 !important;`};
  ${({ minWidth }) => minWidth && `min-width: ${minWidth}px;`}
`;

export const PageContainer = styled(Grid.Container)`
  padding: 12px 0px;
  background-color: white;
  min-height: inherit;
`;

export const PageContents = styled(Grid.Row)`
  padding: 0px 40px;
`;

export const GridRow = styled(Grid.Row)`
  padding-bottom: ${mixins.pxToRem(10)};

  &.first {
    padding-top: ${mixins.pxToRem(20)};
  }
  &.last {
    padding-bottom: ${mixins.pxToRem(20)};
  }

  ${media.lessThan('md')`margin: 0 !important;`};
`;

export const GridCol = styled(Grid.Col)`
  ${media.lessThan('md')`padding: 0 !important;`};
  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor};`}
  ${({ transform }) => transform && `transform: ${transform};`}
`;

export const Row = styled(Grid.Row)`
  &:not(:first-child) {
    padding-top: ${mixins.pxToRem(10)};
  }
  &.spacing {
    padding-top: ${mixins.pxToRem(20)};
  }
`;

export const MobileSpacer = styled.div`
  ${({ lessThan }) => media.lessThan(lessThan)`height: ${mixins.pxToRem(10)}; width: 100%;`};
`;

export const Form = styled.form`
  width: 100%;
`;

export const ItemLabel = styled.div`
  color: ${colorGrey03};
  font-size: 0.8125rem;
  font-weight: 400;
  padding-bottom: 0.5rem;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const RightAlignBackgroundContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  ${({ theme }) => `background-color: ${theme.lighterText}`};
`;

export const stickyStyle = {
  position: 'sticky',
  right: '0',
  backgroundColor: 'white',
  boxShadow: '-4px 0px 25px -10px rgba(0, 0, 0, 0.15)'
};

export const stickyHeader = {
  position: 'sticky',
  right: '0',
  backgroundImage: `linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1))`
};

export const Actions = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

export const ActionLink = styled.button`
  * {
    cursor: ${({ disabled }) => (disabled ? 'default' : `pointer`)};
  }

  &:not(.first) {
    margin-left: 5px 15px;
  }

  div {
    text-transform: uppercase;
    color: ${({ disabled }) => (disabled ? colorGrey03 : `${colorBlue} !important `)};
    padding: ${({ noPadding }) => (noPadding ? '0px' : '5px 15px')};
    text-decoration: ${({ underline }) => (underline ? 'underline' : 'default')};
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  justify-content: space-evenly;
  ${media.greaterThan('lg')`
      flex-wrap: nowrap !important;
  `};
`;

export const StyledRadio = styled(Radio)`
  && {
    ${({ theme }) => `color: ${theme.midTheme} !important`};
    padding: ${mixins.pxToRem(5)};
  }
`;

export const StyledMultiLine = styled(TextInput)`
  && {
    textarea {
      min-height: 20px;
    }
  }
`;

export const Error = styled.div`
  color: ${supplier.error};
  text-align: center;
`;

export const StyledLink = styled.a`
  color: ${({ disabled }) => (disabled ? colorGrey03 : `${colorBlue} !important `)};
  cursor: ${({ disabled }) => (disabled ? 'default' : `pointer`)};
  text-decoration: none;
  text-transform: uppercase;
  padding: ${({ noPadding = false }) => (noPadding ? '0' : '5px 15px')};
  font-family: ${fontBold};
  font-size: ${mixins.pxToRem(10)};
  letter-spacing: 0.5px;
  line-height: ${mixins.pxToRem(14)};
  display: inline-flex;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : `default`)};
  white-space: ${({ nowrap = false }) => (nowrap ? 'nowrap' : '')};
`;

export const CustomLink = styled(StyledLink)`
  padding: 0;
  text-transform: none;
  font-size: 14px;
  font-family: ${fontRegular};
`;

export const ActionButtonBar = styled.span`
  display: flex;
  justify-content: end;
  background-color: ${colorGrey05};
  padding: 6px 19px;
`;
